<mat-form-field floatLabel="always" class="col-12" subscriptSizing="dynamic">
  <mat-label>{{ schema.title }}</mat-label>
  <input
    matInput
    type="number"
    [formControl]="aFormControl"
    [attr.min]="schema.minimum"
    [attr.max]="schema.maximum"
    placeholder="{{ defaultValue || schema.default }}"
  />
  @if (schema.description) {
    <mat-hint>
      {{ schema.description }}
    </mat-hint>
  }
  @if (aFormControl.hasError('min')) {
    <mat-error> Value must be at least {{ schema.minimum }}. </mat-error>
  }
  @if (aFormControl.hasError('max')) {
    <mat-error> Value must be at most {{ schema.maximum }}. </mat-error>
  }
</mat-form-field>
